<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_tax_address_edit">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3">
                    <FormTaxAddress
                            ref="form-tax-address"
                            data-cy="component_modal_tax_address_edit_form"
                    ></FormTaxAddress>
                    <div class="text-right px-2" data-cy="container_modal_tax_address_edit_actions">
                        <button class="bg-gray-300 text-white rounded-md py-1 px-4 mr-2"
                                @click="clickCancel()" data-cy="btn_modal_tax_address_edit_cancel">
                            Cancel
                        </button>
                        <button class="bg-blue-600 text-white rounded-md py-1 px-4"
                                @click="clickOk()" data-cy="btn_modal_tax_address_edit_save">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
// import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import FormTaxAddress from "../../component/FormTaxAddress.vue";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

export default {
    name: "EditTaxAddressModal",
    mixins: [LocaleMixin],
    components: {
        FormTaxAddress
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            addressModel: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.addressModel = config.address;
            document.body.classList.add('not-scroll');
            this.open = true;

            this.$nextTick(() => {
                this.$refs['form-tax-address'].initForm(this.addressModel);
            });
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        clickOk: function () {
            this.saveAddress();
        },

        saveAddress: function() {
            let formData = this.$refs['form-tax-address'].submitForm();
            if (formData != null) {
                let params = formData.getParams();
                this.saveAddressApi(params);
            }
        },
        saveAddressApi: function(params) {
            this.hide();
            this.controller.loadingModal.show();

            BzbsAddressList.apiSaveTaxAddress(params).subscribe(() => {
                this.controller.loadingModal.hide();
                this.controller.sendCallbackEditSuccess();
                // console.log(data);
            }, (err) => {
                this.controller.loadingModal.hide();
                console.log(err);

                let msg = err.message;
                this.controller.alertModal.clearModal()
                        .setMsg(msg)
                        .show();
                this.controller.alertModal.onClickOk(() => {
                    this.show();
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .modal {
        @extend %modal;

        .modal-content {
            width: 420px;

            @include mobile {
                width: 100%;
                padding: 16px;
            }
        }
    }
</style>
